<template lang="html">
  <div>
    <table>
      <tr>
        <td colspan="4"><h1>Datenbank durchsuchen:</h1></td>
      </tr>
      <tr>
        <td>Name:</td>
        <td><input type="text" placeholder="Name" v-model="search.lastname" @keyup="searchStudents()" /></td>
        <td>Vorname:</td>
        <td><input type="text" placeholder="Vorname" v-model="search.firstname" @keyup="searchStudents()" /></td>
      </tr>
      <tr>
        <td>Herkunftsort:</td>
        <td><input type="text" placeholder="Herkunftsort" v-model="search.origin" @keyup="searchStudents()" /></td>
        <td colspan="2"></td>
      </tr>
      <tr>
        <td>Semester:</td>
        <td>
          <select name="semester" v-model="search.semester" @change="searchStudents()">
            <option></option>
            <option v-for="item in semesters" :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </td>
        <td>Fakultät/Fach:</td>
        <td><input type="text" placeholder="Fakultät/Fach" v-model="search.faculty" @keyup="searchStudents()" /></td>
      </tr>
    </table>

    <table width="100%">
      <tr>
        <td colspan="2"><h1>Gefunden: {{ found.size || 0 }}</h1></td>
      </tr>
      <tr v-for="item in found.persons">
        <td><router-link :to="item.id">{{ item.lastname }} {{ item.firstname}}</router-link></td>
        <td>{{ item.origin }}</td>
      </tr>
      <tr class="noprint">
        <td colspan="2"><hr size="1"></td>
      </tr>
      <tr class="noprint">
        <td colspan="2">
          <ul>
            <li><router-link to="/sources">Bio-bibliographische Nachweise</router-link></li>
          </ul></td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['found', 'search', 'semesters'])
  },
  created () {
    if (this.semesters.length === 0) {
      this.listSemesters()
    }
    if (this.found.length === 0) {
      this.searchStudents()
    }
  },
  methods: {
    ...mapActions(['listSemesters', 'searchStudents'])
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// StudentList.vue?6fed3210